import { JetView } from 'webix-jet';
import { profile } from 'config/config';

/**
 * FilterMenuView class extends JetView to create a filter menu interface.
 */
export default class FilterMenuView extends JetView {
    /**
     * Configures the UI components of the filter menu.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        const partners = profile.Partners; // Retrieve partners from profile

        /**
         * Filters partners based on the given partner ID.
         * @param {Object} partners - The partner object to filter.
         * @returns {boolean} True if the partner ID matches, otherwise false.
         */
        function filter_partners(partners) {
            return partners.id == id_partner;
        }

        var partner = partners.filter(filter_partners); // Filter partners based on ID

        const left = {
            margin: 10,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'Country',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Country label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            id: 'Countries',
                            on: {
                                /**
                                 * Enables or disables the button based on selected values.
                                 * @param {string} data - The new value.
                                 * @param {Object} obj - The object that triggered the event.
                                 */
                                onChange: function (data, obj) {
                                    var currentValue = this.getValue();
                                    if (
                                        currentValue.length > 0 &&
                                        $$('Report').getValue().length > 0 &&
                                        $$('Type').getValue().length > 0
                                    ) {
                                        $$('button').enable(); // Enable button if all fields are filled
                                    } else {
                                        $$('button').disable(); // Disable button otherwise
                                    }
                                },
                            },
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: false,
                            minWidth: 200,
                            type: 'month',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: new Date(), // Default to current date
                            format: '%M %Y',
                        },
                        {
                            view: 'combo',
                            name: 'Report',
                            id: 'Report',
                            label: _('Reporte'), // Report label
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '1', value: _('Casino') },
                                { id: '2', value: _('Flujo de caja resumido') },
                                { id: '3', value: _('Informe gerencial') },
                                {
                                    id: '6',
                                    value: _('Informe gerencial usuarios'),
                                },
                                {
                                    id: '7',
                                    value: _('Informe gerencial agentes'),
                                },
                                { id: '4', value: _('Historico de saldos') },
                                {
                                    id: '5',
                                    value: _('Historico de saldos punto de venta'),
                                },
                                {
                                    id: '6',
                                    value: _('Reporte de depósitos'),
                                },
                                {
                                    id: '7',
                                    value: _('Reporte de retiros'),
                                },
                            ],
                            on: {
                                /**
                                 * Enables or disables the button based on selected values.
                                 * @param {string} data - The new value.
                                 * @param {Object} obj - The object that triggered the event.
                                 */
                                onChange: function (data, obj) {
                                    var currentValue = this.getValue();
                                    if (
                                        currentValue.length > 0 &&
                                        $$('Countries').getValue().length > 0 &&
                                        $$('Type').getValue().length > 0
                                    ) {
                                        $$('button').enable(); // Enable button if all fields are filled
                                    } else {
                                        $$('button').disable(); // Disable button otherwise
                                    }
                                },
                            },
                        },
                        {
                            view: 'radio',
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'), // Type label
                            labelPosition: 'top',
                            minWidth: 200,
                            height: screen.width < 500 || screen.height < 500 ? 90 : 0,
                            options: [
                                { id: 'R', value: _('Totales') },
                                { id: 'D', value: _('Detallado') },
                            ],
                            on: {
                                /**
                                 * Enables or disables the button based on selected values.
                                 * @param {string} data - The new value.
                                 * @param {Object} obj - The object that triggered the event.
                                 */
                                onChange: function (data, obj) {
                                    var currentValue = this.getValue();
                                    if (
                                        currentValue.length > 0 &&
                                        $$('Countries').getValue().length > 0 &&
                                        $$('Report').getValue().length > 0
                                    ) {
                                        $$('button').enable(); // Enable button if all fields are filled
                                    } else {
                                        $$('button').disable(); // Disable button otherwise
                                    }
                                },
                            },
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    padding: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 1 },
                        {
                            view: 'button',
                            value: _('Guardar'), // Save button
                            minWidth: 200,
                            click: () => {
                                this.app.callEvent('save:table', []); // Trigger save event
                            },
                        },
                        {
                            view: 'button',
                            value: _('Limpiar'), // Clear button
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear the form
                            },
                        },
                        {
                            view: 'button',
                            id: 'button',
                            value: _('Consultar'), // Consult button
                            type: 'form',
                            minWidth: 200,
                            disabled: true, // Initially disabled
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                filterdata.Partner = partner[0].id; // Add partner ID to filter data
                                this.app.callEvent('control:filter', [
                                    filterdata, // Trigger filter event with data
                                ]);
                                $$('filterPopup').hide(); // Hide filter popup
                                $$('b1').collapse(); // Collapse the accordion
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section, buttons], // Upper section and buttons
            },
        };

        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup', // Popup window for filters
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Popup title
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup on icon click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3], // Content of the popup
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });

        return {
            view: 'form',
            type: 'clean',
            id: 'formFilter',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion section if screen size is adequate
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up the countries dropdown.
     */
    init() {
        var vthis = this; // Reference to the current instance
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        const partners = profile.Partners; // Retrieve partners from profile
        console.log(partners); // Log partners for debugging

        /**
         * Filters partners based on the given partner ID.
         * @param {Object} partners - The partner object to filter.
         * @returns {boolean} True if the partner ID matches, otherwise false.
         */
        function filter_partners(partners) {
            return partners.id == id_partner;
        }

        var partner = partners.filter(filter_partners); // Filter partners based on ID
        var listCountries = partner[0].Countries.filter(
            (item) => item.value != 'Todos' && item.value != 'Default', // Filter out unwanted country options
        );
        $$('Countries').define('options', listCountries); // Define options for the countries dropdown
        $$('Countries').refresh(); // Refresh the dropdown to show new options
    }
}

// FILE DOCUMENTED
